// extracted by mini-css-extract-plugin
export var container = "_fd-1";
export var cornerButtonContainer = "_fd-6";
export var disabled = "_fd-2";
export var dragActive = "_fd-3";
export var fileContainer = "_fd-5";
export var hiddenInput = "_fd-4";
export var widthContainer = "_fd-0";